/**
 * Como se lee el avance de una solicitud.
 *
 * La ruta de estados la manda el backend en el detalle (`ruta`), ya ordenada
 * y filtrada por tipo: Libro a tu clase pasa por preparada y entregada, ARIA
 * no. Aqui solo se interpreta.
 */

/** Los pasos como los espera BarraProceso. */
export const pasosDelProceso = (ruta) =>
  (ruta ?? []).map(({ nombre }) => ({ label: nombre }));

/** En que paso va, o -1 si el estado actual no es parte de la ruta. */
export const pasoActual = (ruta, estado) =>
  (ruta ?? []).findIndex(({ codigo }) => codigo === estado?.codigo);

/**
 * Rechazada o cancelada: el estado actual no esta en la ruta, porque no son
 * parte del camino sino salidas. Ahi no se pinta la barra.
 */
export const salioDeLaRuta = (ruta, estado) => pasoActual(ruta, estado) < 0;

/**
 * El ultimo movimiento del historial. Cuando la solicitud salio de la ruta,
 * su mensaje es el motivo.
 */
export const ultimoMovimiento = (estados) => {
  const lista = estados ?? [];
  return lista.length ? lista[lista.length - 1] : null;
};
